// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__5INXM","selected":"Chip_selected__eMftP"};